<template>
  <div>
    <b-modal
      id="modale-confirmation-ci-cl"
      content-class="modal-bingo-confirm-ci-cl"
      body-class="py-0"
      centered
      hide-header-close
      no-fade
      no-hide-backdrop
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="body-4 texte-noir text-left px-2 py-1" v-html="texteModale" />
      <template #modal-footer>
        <b-row class="row col-12 justify-content-center">
          <b-button
            class="btn btn-primaire w-xs-auto w-md-auto px-4"
            variant="modal"
            @click="redirectValidationIdentite()"
            >{{ $t('messageComponent.continuer') }}</b-button
          >
          <b-button
            class="btn btn-secondaire w-xs-auto w-md-auto px-4"
            variant="modal"
            @click="fermerModale()"
            >{{ $t('messageComponent.annuler') }}</b-button
          >
        </b-row>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { PageMapping } from '@/helpers/PageMappingHelpers';

// Cette Modale ne sera affichée que pour les Clients Invité(ci) et les Clients Léger(cl)
export default {
  name: 'ModaleConfirmationCICL',
  props: { content: { type: Object, required: false } },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          textConfirmationCI: `Le statut actuel de votre compte ne vous permet pas de jouer.<br/>Nous devons d'abord valider votre identité.<br/>Cette vérification ne prendra que quelques secondes.`,
          textConfirmationCL: `<h4>Vous devez compléter votre inscription à Espacejeux pour :</h4><ul><li>acheter de la loterie en ligne;</li><li>jouer au poker, au bingo ou à un éventail de jeux de casino;</li><li></li>parier sur des événements sportifs ou culturels.</ul>`,
          continuer: 'Continuer',
          annuler: 'Annuler',
        },
      },
      en: {
        messageComponent: {
          textConfirmationCI: `Your current account status does not allow you to play.<br/>We must first validate your identity.<br/>The process will only take a few seconds.`,
          textConfirmationCL: `<h4>You must complete your registration on Espacejeux to:</h4><ul><li>Purchase lottery tickets online</li><li>Play poker, bingo or a whole range of casino games</li><li></li>Place bets on sports or cultural events</ul>`,
          continuer: 'Continue',
          annuler: 'Cancel',
        },
      },
    },
  },
  data() {
    return {
      texteModale: '',
    };
  },
  mounted() {
    this.$root.$on('bv::modal::show', () => {
      // eslint-disable-next-line no-undef
      if (/ci/i.test(ejConnect.etatClient)) {
        this.texteModale = this.$i18n.t('messageComponent.textConfirmationCI');
      }
      // eslint-disable-next-line no-undef
      if (/cl/i.test(ejConnect.etatClient)) {
        this.texteModale = this.$i18n.t('messageComponent.textConfirmationCL');
      }
    });
  },
  methods: {
    fermerModale() {
      this.$bvModal.hide('modale-confirmation-ci-cl');
    },
    redirectValidationIdentite() {
      this.fermerModale();
      // On redirige vers la validation d'identité
      window.location.href = `/${this.$i18n.locale}${this.$store.getters[
        'routes/getUrlFromWebsitePath'
      ](PageMapping.IDENTITE_REPRISE.siteUrl)}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-bingo-confirm-ci-cl {
  border: none;
  border-radius: 24px;
  overflow: hidden;
  max-width: 500px;
}
.texte-noir {
  font-weight: 600;
}
</style>
